module.exports = __webpack_public_path__ + "img/LAPTOP.9a3121a6.svg";